import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

import type { ChainWeightingMode } from '~/types/services/priceParrot';

import { chainParityQueryKeys } from './chainParityQueryKeys';

export function useGetChainParitySeries(
  chainName: string | undefined,
  dateFrom: string | undefined,
  dateTo: string | undefined,
  weighting: ChainWeightingMode,
  continent: string | null,
) {
  return useQuery({
    queryKey: chainParityQueryKeys.series(chainName ?? '', dateFrom ?? '', dateTo ?? '', weighting, continent),
    queryFn: async ({ signal }) => {
      if (!chainName || !dateFrom || !dateTo) {
        throw new Error('Chain parity series requires chainName, dateFrom, and dateTo');
      }
      const res = await PriceParrotService.getParityTrendChainSeries(
        chainName,
        {
          date_from: dateFrom,
          date_to: dateTo,
          weighting,
          ...(continent ? { continent } : {}),
        },
        signal,
      );
      return res.data;
    },
    enabled: Boolean(chainName && dateFrom && dateTo),
  });
}
